import { AxiosInstance, AxiosResponse } from "axios"
import { GenericResponse } from "."

export interface MAWBModel {}

export interface PalletModel {}

export interface ReadyLHParcelModel {}

const linehaulApi = (apiInstance: AxiosInstance) => {
    const countriesWithCount = async ({ warehouse }: { warehouse?: string }): Promise<GenericResponse> => {
        let query = ``
        query = warehouse && warehouse !== "" ? `?warehouse_id=${warehouse}` : query
        const res: Promise<GenericResponse> = apiInstance.get(`/countries${query}`)
        return res
    }

    const palletsList = async ({
        warehouse,
        destination,
        page,
        size,
        keyword,
        from,
        to
    }: {
        warehouse: string
        destination: string
        page: number
        size: number
        keyword: string
        from?: string
        to?: string
    }): Promise<GenericResponse> => {
        let query = ``
        query = warehouse && warehouse !== "" ? `?warehouse_id=${warehouse}` : query
        query =
            destination && destination !== ""
                ? `${query && query?.length > 0 ? `${query}&` : "?"}destination=${destination}`
                : query
        query = page && page > 0 ? `${query && query?.length > 0 ? `${query}&` : "?"}page=${page}` : query
        query = size && size > 0 ? `${query && query?.length > 0 ? `${query}&` : "?"}size=${size}` : query
        query =
            keyword && keyword.length > 0
                ? `${query && query?.length > 0 ? `${query}&` : "?"}keyword=${keyword}`
                : query
        query = `${query}${from ? `&from=${from}` : ""}${to ? `&to=${to}` : ""}`
        const res: Promise<GenericResponse> = apiInstance.get(`/pallets${query}`)
        return res
    }

    const palletDetails = async ({ palletId }: { palletId: string }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/pallets/${palletId}`)
        return res
    }

    const createPallet = async ({
        palletData
    }: {
        palletData: Record<string, any>
    }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(`/pallets`, palletData)
        return res
    }

    const updatePallet = async ({
        palletData
    }: {
        palletData: Record<string, any>
    }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(`/pallets/update`, palletData)
        return res
    }

    const deletePallet = async ({ palletId }: { palletId: number }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.delete(`/pallets/delete`, { data: { id: palletId } })
        return res
    }

    const MAWBsList = async ({
        warehouse,
        destination,
        page,
        size,
        keyword,
        from,
        to,
        status
    }: {
        warehouse: string
        destination: string
        page: number
        size: number
        keyword: string
        from?: string
        to?: string
        status?: string
    }): Promise<GenericResponse> => {
        let query = ``
        query = warehouse && warehouse !== "" ? `?warehouse_id=${warehouse}` : query
        query =
            destination && destination !== ""
                ? `${query && query?.length > 0 ? `${query}&` : "?"}destination=${destination}`
                : query
        query = page && page > 0 ? `${query && query?.length > 0 ? `${query}&` : "?"}page=${page}` : query
        query = size && size > 0 ? `${query && query?.length > 0 ? `${query}&` : "?"}size=${size}` : query
        query =
            keyword && keyword.length > 0
                ? `${query && query?.length > 0 ? `${query}&` : "?"}keyword=${keyword}`
                : query
        query = `${query}${from ? `&from=${from}` : ""}${to ? `&to=${to}` : ""}${status ? `&status=${status}` : ""}`
        const res: Promise<GenericResponse> = apiInstance.get(`/mawbs${query}`)
        return res
    }

    const MAWBDetails = async ({ mawb }: { mawb: string }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/mawbs/${mawb}`)
        return res
    }

    const createMAWB = async ({ mawbData }: { mawbData: Record<string, any> }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(`/mawbs`, mawbData)
        return res
    }

    const updateMAWB = async ({ mawbData }: { mawbData: Record<string, any> }): Promise<GenericResponse> => {
        let mawbId = mawbData.id
        delete mawbData["id"]
        const res: Promise<GenericResponse> = apiInstance.put(`/mawbs/${mawbId}`, mawbData)
        return res
    }

    const updateMAWBStatus = async ({
        mawbStatusData
    }: {
        mawbStatusData: Record<string, any>
    }): Promise<GenericResponse> => {
        let mawbId = mawbStatusData.id
        delete mawbStatusData["id"]
        const res: Promise<GenericResponse> = apiInstance.post(`/mawbs/statuses/${mawbId}`, mawbStatusData)
        return res
    }

    const getMAWBAttachmentTypes = async (): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get("/attachments/types")
        return res
    }

    const uploadMAWBAttachment = async ({
        mawbId,
        file_name,
        document_name,
        file,
        description
    }: {
        mawbId: number
        file: string
        file_name: string
        document_name: string
        description?: string
    }): Promise<GenericResponse> => {
        const payload = {
            file_name,
            document_name,
            file,
            description: description
        }
        if (!payload.description) delete payload.description
        const res: Promise<GenericResponse> = apiInstance.post(`/attachments/mawb/${mawbId}`, payload)
        return res
    }

    const deleteMAWBAttachment = async ({
        attachmentId
    }: {
        attachmentId: number
    }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.delete(`/attachments/mawb/${attachmentId}`)
        return res
    }

    const bagsList = async ({
        warehouse,
        destination,
        page,
        size,
        keyword
    }: {
        warehouse: string
        destination: string
        page: number
        size: number
        keyword: string
    }): Promise<GenericResponse> => {
        let query = ``
        query = warehouse && warehouse !== "" ? `?warehouse_id=${warehouse}` : query
        query =
            destination && destination !== ""
                ? `${query && query?.length > 0 ? `${query}&` : "?"}destination=${destination}`
                : query
        query = page && page > 0 ? `${query && query?.length > 0 ? `${query}&` : "?"}page=${page}` : query
        query = size && size > 0 ? `${query && query?.length > 0 ? `${query}&` : "?"}size=${size}` : query
        query =
            keyword && keyword.length > 0
                ? `${query && query?.length > 0 ? `${query}&` : "?"}keyword=${keyword}`
                : query
        const res: Promise<GenericResponse> = apiInstance.get(`/bags${query}`)
        return res
    }

    // these bags include the bags from selected destination in addition to the bags from other destinations which their type is in-transit
    const transitBagsList = async ({
        warehouse,
        destination
    }: {
        warehouse: string
        destination: string
    }): Promise<GenericResponse> => {
        let query = ``
        const page = 1
        const size = 500
        query = warehouse && warehouse !== "" ? `?warehouse_id=${warehouse}` : query
        query =
            destination && destination !== ""
                ? `${query && query?.length > 0 ? `${query}&` : "?"}destination=${destination}`
                : query
        query = page && page > 0 ? `${query && query?.length > 0 ? `${query}&` : "?"}page=${page}` : query
        query = size && size > 0 ? `${query && query?.length > 0 ? `${query}&` : "?"}size=${size}` : query
        query = `${query}&bag_transit=true`
        const res: Promise<GenericResponse> = apiInstance.get(`/bags${query}`)
        return res
    }

    const bagDetails = async ({ bagId }: { bagId: string }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/bags/${bagId}`)
        return res
    }

    const createBag = async ({ bagData }: { bagData: Record<string, any> }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(`/bag/create`, bagData)
        return res
    }

    const updateBag = async ({ bagData }: { bagData: Record<string, any> }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(`/bag/update`, bagData)
        return res
    }

    const deleteBag = async ({ bagId }: { bagId: number }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.delete(`/bags/delete`, { data: { id: bagId } })
        return res
    }

    const LineHaulStatuses = async ({ warehouse }: { warehouse?: string }): Promise<GenericResponse> => {
        let query = ``
        query = warehouse && warehouse !== "" ? `?warehouse_id=${warehouse}` : query
        const res: Promise<GenericResponse> = apiInstance.get(`/mawbs/statuses${query}`)
        return res
    }

    const destinations = async (): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/destination`)
        return res
    }

    const readyLHParcelsList = async ({
        warehouse,
        destination
    }: {
        warehouse?: string
        destination?: string
        page?: number
        size?: number
    }): Promise<GenericResponse> => {
        let query = ``
        query = warehouse && warehouse !== "" ? `?warehouse_id=${warehouse}` : query
        query =
            destination && destination !== ""
                ? `${query && query?.length > 0 ? `${query}&` : "?"}destination=${destination}`
                : query
        // query = page && page > 0 ? `${query && query?.length > 0 ? `${query}&` : "?" }page=${page}` : query
        // query = size && size > 0 ? `${query && query?.length > 0 ? `${query}&` : "?" }size=${size}` : query
        const res: Promise<GenericResponse> = apiInstance.get(`/parcels${query}`)
        return res
    }

    const exportManifest = async ({
        category,
        uid,
        warehouse,
        country
    }: {
        category: "mawb" | "pallet" | "bag"
        uid: string
        warehouse: string
        country: string
    }): Promise<GenericResponse> => {
        let query = ``
        query = warehouse && warehouse !== "" ? `?warehouse_id=${warehouse}` : query
        query =
            country && country !== ""
                ? `${query && query?.length > 0 ? `${query}&` : "?"}country=${country}`
                : query
        const res: Promise<GenericResponse> = apiInstance.get(`/${category}/manifest/${uid}${query}`)
        return res
    }

    const allPalletsList = async ({
        warehouse,
        destination,
        keyword
    }: {
        warehouse: string
        destination: string
        keyword: string
    }): Promise<GenericResponse> => {
        let query = ``
        query = warehouse && warehouse !== "" ? `?warehouse_id=${warehouse}` : query
        query =
            destination && destination !== ""
                ? `${query && query?.length > 0 ? `${query}&` : "?"}destination=${destination}`
                : query
        query =
            keyword && keyword.length > 0
                ? `${query && query?.length > 0 ? `${query}&` : "?"}keyword=${keyword}`
                : query
        const res: Promise<GenericResponse> = apiInstance.get(`/pallets${query}&includeMawbPallets=false`)
        return res
    }

    const exportList = async ({
        warehouse,
        keyword,
        from,
        key,
        status,
        to
    }: {
        warehouse: string
        keyword?: string
        from?: string
        to?: string
        key: "lhMawbs" | "lhPallets" | "lhBags"
        status?: string
    }) => {
        const queryParams: any = {
            warehouse_id: warehouse,
            keyword,
            from,
            to,
            key,
            status
        }
        var queryString = Object.keys(queryParams)
            .filter((param) => !!queryParams[param])
            .map((param) => param + "=" + queryParams[param])
            .join("&")
        const res = apiInstance.get<unknown, AxiosResponse<string, unknown>>(`/export?${queryString}`)
        return res
    }

    return {
        countriesWithCount,
        palletsList,
        palletDetails,
        createPallet,
        updatePallet,
        deletePallet,
        bagsList,
        bagDetails,
        createBag,
        updateBag,
        deleteBag,
        MAWBsList,
        MAWBDetails,
        readyLHParcelsList,
        createMAWB,
        updateMAWB,
        updateMAWBStatus,
        LineHaulStatuses,
        exportManifest,
        allPalletsList,
        getMAWBAttachmentTypes,
        uploadMAWBAttachment,
        deleteMAWBAttachment,
        exportList,
        destinations,
        transitBagsList
    }
}

export default linehaulApi
